/**
 * Bootstrap de publicación de tienda para el sidebar — no depende de montar Inicio.
 * Perfil cacheado (TTL + dedupe); evita menú Tienda falso pre-Home.
 */
import { useEffect } from 'react';
import { useSessionStore } from '../../shell/session/store/useSessionStore';
import { readStorePublished } from '../application/storeActivationEvidence';
import { useDay1PathNavStore } from '../store/useDay1PathNavStore';

export function useStorefrontPublishBootstrap() {
  const branchId = useSessionStore((s) => s.currentBranchId);
  const setStorePublished = useDay1PathNavStore((s) => s.setStorePublished);

  useEffect(() => {
    if (!branchId) {
      setStorePublished(null);
      return;
    }
    let cancelled = false;
    setStorePublished(null);
    void readStorePublished(branchId).then((published) => {
      if (cancelled) return;
      setStorePublished(published === true);
    });
    return () => {
      cancelled = true;
    };
  }, [branchId, setStorePublished]);
}
